import { getRepository } from '@things-factory/shell'
import { Kpi } from '../service/kpi/kpi'
import { KpiValue } from '../service/kpi-value/kpi-value'
import { ValueProvider } from '../calculator/provider'

export class KpiValueProvider implements ValueProvider {
  constructor(
    private options: {
      valueDate: string
      org?: string
      domainId: string
      tx?: any
    }
  ) {}

  async get(name: string) {
    const kpiRepo = getRepository(Kpi, this.options.tx)
    const kpi = await kpiRepo.findOne({ where: { name, domain: { id: this.options.domainId } } })
    if (!kpi) throw new Error(`KPI not found: ${name}`)
    const valueRepo = getRepository(KpiValue, this.options.tx)

    // SINGLE 타입인 경우 valueDate 무시하고 최신 값 조회
    const whereCondition: any = {
      kpi: { id: kpi.id },
      org: this.options.org ?? '',
      domain: { id: this.options.domainId }
    }

    if (kpi.periodType === 'ALLTIME') {
      // ALLTIME 타입은 valueDate 무시하고 최신 version → createdAt 순으로 1건
      const value = await valueRepo.findOne({
        where: whereCondition,
        order: { version: 'DESC', createdAt: 'DESC' }
      })
      if (!value) {
        throw new Error(`KPI value not found: kpi='${name}', org='${this.options.org ?? ''}' (ALLTIME type)`)
      }
      return value.value
    } else {
      // 같은 (kpi, valueDate, org, domain) 좌표에 여러 version 가능 →
      // version DESC 으로 latest 보장.
      whereCondition.valueDate = this.options.valueDate
      const value = await valueRepo.findOne({
        where: whereCondition,
        order: { version: 'DESC' }
      })
      if (!value) {
        throw new Error(
          `KPI value not found: kpi='${name}', org='${this.options.org ?? ''}', valueDate='${this.options.valueDate}'`
        )
      }
      return value.value
    }
  }
}
